import Footer from '@common/components/Footer';

export default Footer;
